import React from 'react';
import { useTranslation } from 'next-i18next';
import Title from '@/components/Teachers/Title';
import styles from './style.module.scss';
import contactIcon from './assets/contacts.svg';
import mailIcon from './assets/mail.svg';

interface CooperationItemProps {
  name: string;
  desc: string;
  contacts: string;
  mail: string;
  color: string;
  shadowColor: string;
}

const CooperationItem: React.FC<CooperationItemProps> = ({ desc, name, contacts, mail, color, shadowColor }) => {
  return (
    <div className={styles.cooperation} style={{ boxShadow: `0px 4px 14px ${shadowColor}` }}>
      <dl>
        <dt className={styles.name} style={{ background: color }} dangerouslySetInnerHTML={{ __html: name }} />
        <dd className={styles.desc}>{desc}</dd>
      </dl>
      <div className={styles.contacts}>
        <img src={contactIcon.src} className={styles.icon} alt="" />
        <span className={styles.text}>{contacts}</span>
      </div>
      <div className={styles.contacts}>
        <img src={mailIcon.src} className={styles.icon} alt="" />
        <a href={`mailto:${mail}`} className={styles.text}>
          {mail}
        </a>
      </div>
      {/* <div className={styles.contacts}>
        <img src={wechatIcon.src} className={styles.icon} alt="" />
        <span className={styles.text}>{wechat}</span>
      </div> */}
    </div>
  );
};

const Cooperation = () => {
  const { t } = useTranslation('joinus');
  const cooperations: CooperationItemProps[] = [
    {
      name: t('联系方式-1-标题'),
      desc: t('联系方式-1-说明'),
      contacts: t('联系方式-1-姓名'),
      mail: t('联系方式-1-联系'),
      // wechat: 'bu-xiaomi',
      color: '#FF6666',
      shadowColor: '#FFE6EC',
    },
    {
      name: t('联系方式-2-标题'),
      desc: t('联系方式-2-说明'),
      contacts: t('联系方式-2-姓名'),
      mail: t('联系方式-2-联系'),
      // wechat: 'weilailittlefupo',
      color: '#009CFF',
      shadowColor: '#D8E7FE',
    },
    {
      name: t('联系方式-3-标题'),
      desc: t('联系方式-3-说明'),
      contacts: t('联系方式-3-姓名'),
      mail: t('联系方式-3-联系'),
      // wechat: 'gjy184220097',
      color: '#FFD400',
      shadowColor: '#FCF3C7',
    },
  ];
  return (
    <section className={styles.container}>
      <Title id="wukong-cooperation">{t('联系方式-标题')}</Title>

      <div className={styles.swiper}>
        {cooperations.map((item) => {
          return <CooperationItem {...item} key={item.name} />;
        })}
      </div>
    </section>
  );
};

export default Cooperation;
